import { AdminLink } from '../AdminLink/AdminLink';

export const SiteMaterialCompanyLink = ({
  children,
  tradeCompanyId,
  siteMaterialId,
}: {
  children: React.ReactNode;
  tradeCompanyId: number;
  siteMaterialId: string;
}) => {
  return (
    <AdminLink
      href={`/ground-control/v2/manage-company/${tradeCompanyId}/site-materials/${siteMaterialId}`}
      target="_blank"
      sx={{
        '@media print': {
          display: 'none',
        },
      }}
    >
      {children}
    </AdminLink>
  );
};
